import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  background: white;
  border-radius: 2px;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 95vh;
  }

  .icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }
`;

/* ===== Seção de Detalhes da Solicitação (topo azul) ===== */
export const RequestDetailCard = styled.div`
  background: #00467E;
  overflow: visible;
`;

export const RequestDetailHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1.25rem;
`;

export const RequestDetailTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 1.125rem;
  font-weight: 600;

  svg {
    font-size: 1.375rem;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const RequestDetailInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 1.25rem 0.75rem;
  flex-wrap: wrap;
`;

export const InfoItem = styled.span`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;

  svg {
    font-size: 0.875rem;
  }
`;

export const RequestDetailBody = styled.div`
  padding: 0 1.25rem 1.25rem;
`;

export const RequestLabel = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9375rem;
  margin-bottom: 0.75rem;
  font-weight: 500;
`;

export const RequestVideoWrapper = styled.div`
  background-color: #000;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 0.75rem;
`;

export const RequestVideo = styled.video`
  width: 100%;
  height: auto;
  display: block;
  background-color: #000;
  object-fit: contain;
`;

export const RequestContent = styled.p`
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9375rem;
  line-height: 1.6;
  font-style: italic;
  margin-top: 0.75rem;
`;

/* ===== Seção de Resposta ===== */
export const ReplySection = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
`;

export const ReplyTabs = styled.div`
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const ReplyTab = styled.button<{ isActive: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: ${(props) => (props.isActive ? "white" : "transparent")};
  border: none;
  border-bottom: 2px solid ${(props) => (props.isActive ? "#0672CB" : "transparent")};
  color: ${(props) => (props.isActive ? "#0672CB" : "#666")};
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  svg {
    font-size: 1.25rem;
  }

  &:hover {
    background: rgba(0, 103, 178, 0.05);
  }
`;

export const ReplyTabContent = styled.div`
  padding: 1.5rem 1.25rem;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 0.875rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  font-size: 0.9375rem;
  font-family: "Roboto", sans-serif;
  color: #333;
  resize: none;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder {
    color: #aaa;
  }

  &:focus {
    border-color: #0672CB;
  }
`;

export const VideoUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 1rem;
`;

export const VideoUploadIcon = styled.div`
  font-size: 5rem;
  color: #b0b8c1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoUploadText = styled.p`
  color: #7e8a98;
  font-size: 1rem;
  margin: 0;
`;

export const VideoPreview = styled.video`
  width: 100%;
  height: auto;
  min-height: 240px;
  max-height: 360px;
  border-radius: 2px;
  background-color: #000;
  object-fit: cover;
  display: block;
`;

export const VideoActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  padding: 0 1.25rem 1rem;
`;

export const VideoActionButton = styled.button<{ primary?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background-color: ${(props) => (props.primary ? "#0672CB" : "transparent")};
  color: ${(props) => (props.primary ? "white" : "#1D2C3B")};
  border: ${(props) => (props.primary ? "none" : "1px solid rgba(0, 0, 0, 0.2)")};
  border-radius: 2px;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  svg {
    font-size: 1.125rem;
  }

  &:hover {
    background-color: ${(props) =>
      props.primary ? "#0563b0" : "rgba(0, 0, 0, 0.05)"};
  }
`;

export const ReplyFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

export const CancelButton = styled.button`
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: #1D2C3B;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.5rem;
  background-color: #0672CB;
  color: white;
  border: none;
  border-radius: 2px;
  font-size: 0.9375rem;
  font-weight: 500;

  svg {
    font-size: 1.125rem;
  }

  &:hover {
    background-color: #0563b0;
  }

  &:disabled {
    background-color: #aaa;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Toast = styled.div<{ type: "success" | "error" }>`
  position: fixed;
  bottom: 5rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.875rem 1.5rem;
  border-radius: 2px;
  color: white;
  font-size: 0.9375rem;
  font-weight: 500;
  z-index: 10000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  background-color: ${({ type }) => type === "success" ? "#1a7f4e" : "#c0392b"};
  animation: slideUp 0.30s ease;

`;

